import { render, staticRenderFns } from "./CompanyAboutTheData.vue?vue&type=template&id=031e79df"
import script from "./CompanyAboutTheData.vue?vue&type=script&lang=js"
export * from "./CompanyAboutTheData.vue?vue&type=script&lang=js"
import style0 from "./CompanyAboutTheData.vue?vue&type=style&index=0&id=031e79df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports